/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { AggregationSettings } from "./AggregationSettings";
import {
  AggregationSettingsFromJSON,
  AggregationSettingsFromJSONTyped,
  AggregationSettingsToJSON,
  AggregationSettingsToJSONTyped,
} from "./AggregationSettings";

/**
 *
 * @export
 * @interface PaginatedAggregationSettingsList
 */
export interface PaginatedAggregationSettingsList {
  /**
   *
   */
  count: number;
  /**
   *
   */
  next?: string | null;
  /**
   *
   */
  previous?: string | null;
  /**
   *
   */
  results: Array<AggregationSettings>;
}

/**
 * Check if a given object implements the PaginatedAggregationSettingsList interface.
 */
export function instanceOfPaginatedAggregationSettingsList(
  value: object
): value is PaginatedAggregationSettingsList {
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function PaginatedAggregationSettingsListFromJSON(
  json: any
): PaginatedAggregationSettingsList {
  return PaginatedAggregationSettingsListFromJSONTyped(json, false);
}

export function PaginatedAggregationSettingsListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PaginatedAggregationSettingsList {
  if (json == null) {
    return json;
  }
  return {
    count: json["count"],
    next: json["next"] === undefined ? undefined : json["next"] === null ? null : json["next"],
    previous:
      json["previous"] === undefined
        ? undefined
        : json["previous"] === null
        ? null
        : json["previous"],
    results: (json["results"] as Array<any>).map(AggregationSettingsFromJSON),
  };
}

export function PaginatedAggregationSettingsListToJSON(
  json: any
): PaginatedAggregationSettingsList {
  return PaginatedAggregationSettingsListToJSONTyped(json, false);
}

export function PaginatedAggregationSettingsListToJSONTyped(
  value?: PaginatedAggregationSettingsList | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    count: value["count"],
    next: value["next"],
    previous: value["previous"],
    results: (value["results"] as Array<any>).map(AggregationSettingsToJSON),
  };
}
